import WideHome from "@/layouts/WideHome/WideHome.vue";
import Advertising from "@/components/Advertising/Advertising.vue";
import MainHeader from "@/components/MainHeader/MainHeader.vue";
import MobileNav from "@/components/MobileNav/MobileNav.vue";
import SpanishHeader from "@/components/SpanishHeader/SpanishHeader.vue";
import { mapGetters } from "vuex";

export default {
    name: "LayoutWide",
    components: {
        Advertising,
        MainHeader,
        MobileNav,
        SpanishHeader
    },
    data() {
        return {
            mobileNavIsOpen: false
        };
    },
    methods: {
        mobileMenuToggle(value) {
            this.mobileNavIsOpen = value;
        }
    },
    computed: {
        ...mapGetters(["currentLanguage"])
    },
    created() {
        this.$parent.$emit("update:layout", WideHome);
    }
};



// WEBPACK FOOTER //
// ./src/layouts/WideHome/WideHome.js